import {CommonRootState} from '../types';

export const selectWeatherflowConnectedAt = (state: CommonRootState) =>
  state.weatherflow.link && state.weatherflow.link.date_connected;

export const selectWeatherflowConnected = (state: CommonRootState) =>
  state.weatherflow.link !== null;

export const selectWeatherflowActive = (state: CommonRootState) =>
  state.weatherflow.link !== null && state.weatherflow.link.account.active;
